import React, { useMemo } from 'react';
import { FormattedDate } from 'react-intl';
import { isValid, parseISO } from 'date-fns';

const DateLineItem = (props) => {
    const isValidDate = useMemo(() => isValid(parseISO(props.value)), [props.value]);

    if (!isValidDate) {
        return (
            <React.Fragment>
                ---
                <span className="visually-hidden">not available</span>
            </React.Fragment>
        );
    }

    const { value, ...restOfProps } = props;
    const date = value.split('-');

    return (
        <FormattedDate
            day="2-digit"
            month="long"
            year="numeric"
            {...restOfProps}
            value={new Date(date[0], parseInt(date[1]) - 1, date[2])}
        />
    );
};

export default DateLineItem;
